import React from "react";
import "../Styles/BookingStatusModal.css";

const BookingStatusModal = ({
  status = "loading", // "loading" | "success" | "error"
  title,
  message,
  onClose,
}) => {
  const renderIcon = () => {
    if (status === "loading") {
      return <div className="spinner" />;
    }

    if (status === "success") {
      return <div className="success-check">✓</div>;
    }

    if (status === "error") {
      return <div className="error-cross">✕</div>;
    }

    return null;
  };

  const renderTitle = () => {
    if (title) return title;

    if (status === "loading") return "Booking in progress";
    if (status === "success") return "Booking Confirmed";
    if (status === "error") return "Booking Failed";

    return "";
  };

  const renderMessage = () => {
    if (message) return message;

    if (status === "loading") {
      return "Please wait while we confirm your appointment.";
    }

    if (status === "success") {
      return (
        <>
          Your appointment has been successfully booked.
          <br />
          Clinic will get in touch with you shortly.
        </>
      );
    }

    if (status === "error") {
      return "Something went wrong. Please try again.";
    }

    return "";
  };

  return (
    <div className="booking-status-overlay">
      <div className="booking-status-box">
        <div className="status-icon">{renderIcon()}</div>

        <h3>{renderTitle()}</h3>

        <p>{renderMessage()}</p>

        {status !== "loading" && (
          <button onClick={onClose} className="status-close-btn">
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default BookingStatusModal;
